// extracted by mini-css-extract-plugin
export default {"heading":"gC4i3kfCDLvzIdOZAVZs"};